import React from 'react';
import { Center, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HelpdeskContactButton } from 'HelpdeskContactButton';

const AccessDenied = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Center w='100%' h='100%'>
      <Flex
        fontSize='4rem'
        fontWeight='bold'
        align='center'
        justify='center'
        direction='column'
      >
        <Heading>403</Heading>
        <Text fontSize='3rem' mt={2} color='graphite.500'>
          {t('accessDenied', 'Dostęp zabroniony')}
        </Text>
        <Text fontSize='sm' mt={2} color='graphite.500'>
          {t(
            'accessDeniedHelpdesk',
            'Jeśli potrzebujesz pomocy, skontaktuj się z naszym helpdeskiem:',
          )}
        </Text>
        <HelpdeskContactButton />
      </Flex>
    </Center>
  );
};

export default AccessDenied;
